<template>
  <div>
    <div class="d-flex topbar">
      <nav aria-label="breadcrumb" class="mr-auto">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <router-link :to="{name: 'SearchList'}">Mes Recherches</router-link>
          </li>
          <li class="breadcrumb-item">
            <router-link :to="{name: 'SearchDetails', params: {id: searchId}}">Recherche</router-link>
          </li>
          <li class="breadcrumb-item active d-none d-sm-block" aria-current="page">Paramètres &amp; Membres</li>
        </ol>
      </nav>

      <div class="dropdown expand-md">
          <button class="btn btn-primary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <i class="icon fa fa-cogs"></i>
          </button>

          <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
            <router-link class="dropdown-item" :to="{name: 'SearchQueries', params: {id: searchId}}">
              <i class="icon fa fa-sliders-h"></i> Requêtes
            </router-link>
          </div>
        </div>

      <ul class="nav ml-auto collapse-md">
          <li class="nav-item">
            <router-link class="nav-link" :to="{name: 'SearchQueries', params: {id: searchId}}">
              <i class="icon fa fa-sliders-h"></i> Requêtes
            </router-link>
          </li>
        </ul>
    </div>

    <div class="jumbotron">
      <h1>PAramètres &amp; Membres</h1>
      <h4>
        Modifiez les informations de base de votre recherche et gérez vos co-chercheurs
      </h4>
    </div>

    <div class="container">
      <form>
        <div class="control-group">
          <div class="form-group floating-label-form-group controls mb-0 pb-2">
            <label>Nom de votre recherche</label>
            <input
              type="text"
              class="form-control"
              v-model="form.name"
              aria-describedby="searchNameHelp"
              placeholder="Nom de votre recherche"
            />
            <small
              id="searchNameHelp"
              class="form-text text-muted"
            >Décrivez le nom de votre recherche</small>
          </div>
        </div>

        <div class="control-group">
          <div class="form-group floating-label-form-group controls mb-0 pb-2">
            <label>Description</label>
            <textarea
              rows="3"
              type="text"
              class="form-control"
              v-model="form.description"
              aria-describedby="descriptionHelp"
              placeholder="Description"
            />
            <small
              id="descriptionHelp"
              class="form-text text-muted"
            >Décrivez le pourquoi du comment de votre recherche, cela sera notamment utilisé lors des invitations auprès de vos co-chercheurs</small>
          </div>
        </div>

        <br />
        <div class="row">
          <div class="col-md-12">
            <button type="submit" class="btn btn-primary btn-xl btn-submit" @click="saveSearch()" v-show="!status.loading">Mettre à jour la recherche</button>

            <div class="spinner-border text-primary" role="status" v-show="status.loading">
              <span class="sr-only">Mise à jour en cours...</span>
            </div>
          </div>
        </div>
        <br />

        <div class="list-users">
          <h2>Définissez vos co-cherheurs</h2>
          <small>Invitez ici vos co-chercheurs. Ils recevront alors une invitation pour participer à cette recherche.</small>
          <br />
          <br />

          <div class="row item-user" v-for="(user, index) in form.searchUsers">
            <div class="col-md-4">
              <input type="text" class="form-control" v-model="user.fullName" placeholder="Nom ou pseudo de votre co-chercheur" />
            </div>
            <div class="col-md-5">
              <input type="email" class="form-control" v-model="user.email" placeholder="Email de votre co-chercheur" v-bind:readonly="!user.isNew" />
            </div>
            <div class="col-md-3">
              <button type="button" @click="saveUser(index)" class="btn btn-secondary btn-m" :disabled="user.loading">Sauvegarder</button>
              <button type="button" @click="deleteUser(index)" class="btn btn-outline-light btn-social mx-1 btn-close">X</button>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <button type="button" class="btn btn-secondary btn-l btn-addco" @click="addEmptyUser()"><i class="fas fa-user mr-2"></i>Ajouter un autre co-chercheur</button>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'

  export default {
    name: 'SearchMembers',
    props: ['id'],
    searchId: 0,
    data() {
      return {
        searchId: 0,
        status: { loading: false, errorMessage: null },
        form: { name:"", description:"", searchUsers: [] }
      }
    },
    mounted () {
      var tempSearch = {};

      var vm = this;

      this.searchId = this.$route.params.id;

      vm.status.loading = true;

      axios
        .get(process.env.BACKEND_URL + '/api/searches/' + this.$route.params.id)
        .then(response => {
          tempSearch = response.data

          console.log(tempSearch.name);
          vm.form.name = tempSearch.name;
          vm.form.description = tempSearch.description;

          tempSearch.searchUserLinks.forEach(userLink => {
            vm.form.searchUsers.push({ fullName: userLink.user.fullName, email: userLink.user.email, isNew: false })
          });

          vm.status.loading = false;
        })
        .catch(error => {
          if (error.response) {
            if (error.response.status == 500)
              vm.status.errorMessage = "Erreur serveur : <br /><i>" + JSON.stringify(error.response.data) + "</i>";
          } else
            vm.status.errorMessage = "Erreur lors de la requête de connexion auprès du serveur";

          vm.status.loading = false;
        });

    },
    methods: {
      deleteUser: function (index) {
        var vm = this

        vm.form.searchUsers[index].loading = true;

        if(vm.form.searchUsers[index].isNew){
            var user = vm.form.searchUsers.splice(index, 1);
        }else{
          axios
            .delete(process.env.BACKEND_URL + '/api/searches/' + this.$route.params.id + '/members/' + vm.form.searchUsers[index].email)
            .then(response => {
              var user = vm.form.searchUsers.splice(index, 1);
            })
        }
        return false;
      },
      saveUser: function (index) {
        var vm = this

        vm.form.searchUsers[index].loading = true;

        axios
          .put(process.env.BACKEND_URL + '/api/searches/' + this.$route.params.id + '/members', vm.form.searchUsers[index])
          .then(response => {
            console.log(response)
            vm.form.searchUsers[index].isNew = false
            vm.form.searchUsers[index].loading = false
          })

        return false;
        
      },
      addEmptyUser: function () {
        var vm = this
        vm.form.searchUsers.push({fullName: "", email: "", isNew: true, loading: false})
      },
      saveSearch: function () {
        var vm = this;

        vm.status.loading = true;
        
        axios
          .put(process.env.BACKEND_URL + '/api/searches/' + this.$route.params.id, vm.form)
          .then(response => {
            // vm.$router.push({name: 'SearchDetails', params: {id: response.data.searchId} });
            vm.status.loading = false;
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 500)
                vm.status.errorMessage = "Erreur serveur : <br /><i>" + JSON.stringify(error.response.data) + "</i>";
            } else
              vm.status.errorMessage = "Erreur lors de la requête de connexion auprès du serveur";

            vm.status.loading = false;
          });

        return false;
      }
    }
  }
</script>

<style scope>
.btn-close{
  color: #ced4da;
  border-color: #ced4da;
  width: 2.25rem;
  height: 2.25rem;
  font-size: 1;
}

.btn-addco{
  margin-top: 10px;
}

.btn-submit{
  margin-top: 20px;
}

.item-user{
  margin-bottom: 10px;
}

  .search-items {
  }

    .search-items .search-item {
      margin-bottom: 10px;
    }

      .search-items .search-item .search-item-picture {
        max-height: 150px;
      }
</style>



// WEBPACK FOOTER //
// src/components/SearchMembers.vue